import React, { createContext, useState, useEffect } from "react";

export const EstabelecimentosContext = createContext();

export function EstabelecimentosProvider({ children }) {
    const [estabelecimentos, setEstabelecimentos] = useState([]);
    const [todosEstabelecimentos, setTodosEstabelecimentos] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchEstabelecimentos = async () => {
        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
            const idUniversidade = localStorage.getItem('id_universidade');
            const tipoUsuario = localStorage.getItem('tipo_usuario');

            // O filtro por universidade só faz sentido pro CLIENTE navegando o
            // "praça de alimentação" de uma universidade — admin/equipe/master
            // usam esta mesma lista pra localizar o estabelecimento selecionado
            // no seletor (Configurações, Personalização da Loja etc.), e um
            // admin pode ter estabelecimentos em universidades diferentes (ou um
            // Restaurante avulso sem universidade). Se aplicasse o filtro pra
            // eles também, trocar de estabelecimento no seletor faria essa
            // lista ficar presa à universidade do login e não achar mais o
            // estabelecimento recém-selecionado.
            let url = `${API_URL}/estabelecimentos`;

            if (idUniversidade && tipoUsuario === 'cliente') {
                url = `${API_URL}/universidades/${idUniversidade}/estabelecimentos`;
                console.log(`🎓 [ESTABELECIMENTOS] Buscando estabelecimentos da universidade ${idUniversidade}`);
            } else {
                console.log("🏢 [ESTABELECIMENTOS] Buscando todos os estabelecimentos (sem filtro de universidade)");
            }

            console.log(`📡 [ESTABELECIMENTOS] URL: ${url}`);
            const response = await fetch(url, { cache: 'no-store' });

            if (!response.ok) {
                console.error(`❌ [ESTABELECIMENTOS] Erro HTTP ${response.status} ao buscar estabelecimentos`);
                setEstabelecimentos([]);
                setLoading(false);
                return;
            }

            const data = await response.json();
            const lista = Array.isArray(data) ? data : [];
            console.log(`✅ [ESTABELECIMENTOS] ${lista.length} estabelecimento(s) encontrado(s)`);
            setEstabelecimentos(lista);
            setLoading(false);
        } catch (error) {
            console.error("❌ [ESTABELECIMENTOS] Erro ao buscar estabelecimentos:", error);
            setLoading(false);
        }
    };

    const fetchTodosEstabelecimentos = async () => {
        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
            const token = localStorage.getItem('token');

            const response = await fetch(`${API_URL}/master/estabelecimentos`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error('Erro ao buscar estabelecimentos');
            }

            const data = await response.json();
            setTodosEstabelecimentos(data);
            setLoading(false);
        } catch (error) {
            console.error("Erro ao buscar todos estabelecimentos:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEstabelecimentos();
        // NÃO chamar fetchTodosEstabelecimentos aqui - será chamado manualmente pelas páginas master

        // Listener para detectar mudanças no localStorage (login/logout)
        const handleStorageChange = () => {
            console.log("🔄 [ESTABELECIMENTOS] LocalStorage alterado, recarregando estabelecimentos...");
            fetchEstabelecimentos();
        };

        // Listener para eventos personalizados de mudança de universidade
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('loginSuccess', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('loginSuccess', handleStorageChange);
        };
    }, []);

    return (
        <EstabelecimentosContext.Provider value={{
            estabelecimentos,
            todosEstabelecimentos,
            loading,
            fetchEstabelecimentos,
            fetchTodosEstabelecimentos
        }}>
            {children}
        </EstabelecimentosContext.Provider>
    );
}
